import { Crop } from '../components/FlexImageCropper';

interface Props {
  adjustedCrop?: Crop;
  base64src: string;
  callback: (imagePreview: any) => void;
}

export default ({ base64src, adjustedCrop, callback }: Props): void => {
  const canvas = document.createElement('canvas');
  const image = new Image();
  image.onload = (): void => {
    const context = canvas.getContext('2d');

    if (adjustedCrop) {
      const { x, y, width, height } = adjustedCrop;

      canvas.width = width;
      canvas.height = height;

      if (context) {
        context.drawImage(image, x, y, width, height, 0, 0, width, height);
      }
    } else if (context) {
      context.drawImage(image, 0, 0);
    }

    callback(canvas.toDataURL('image/jpeg'));
  };
  image.src = base64src;
};
